/**
 * Bundle entry point.
 *
 * Exposes `window.LickdImpactCalculator.mount(target)` and auto-mounts
 * any element carrying `data-crescendo-impact-calculator` once the DOM is ready, so
 * the widget can be embedded either programmatically or with pure markup:
 *
 *   <div data-crescendo-impact-calculator></div>
 *   <script src="https://.../crescendo-impact-calculator.js"></script>
 */
import { mount, type MountHandle, type MountOptions } from './mount';

const api = {
  mount,
  /** Mount every element with the data-crescendo-impact-calculator attribute. */
  autoMount(): MountHandle[] {
    const nodes = Array.from(
      document.querySelectorAll<HTMLElement>('[data-crescendo-impact-calculator]'),
    );
    return nodes
      .filter((el) => !el.dataset.lickdMounted)
      .map((el) => {
        el.dataset.lickdMounted = 'true';
        const { eventPrefix, signupRef } = el.dataset;
        return mount(el, { eventPrefix, signupRef });
      });
  },
};

declare global {
  interface Window {
    LickdImpactCalculator: typeof api;
    dataLayer?: Record<string, unknown>[];
  }
}

window.LickdImpactCalculator = api;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => api.autoMount());
} else {
  api.autoMount();
}

export type { MountHandle, MountOptions };
export { mount };
